import BaseModel from '@danhoss/model/BaseModel';

export class CategoryModel extends BaseModel {
    constructor() {
        super();

        this._id = Number;
        this._name = String;
        this._description = String;
        this._image = String;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get description() {
        return this._description;
    }

    set description(value) {
        this._description = value;
    }

    get image() {
        return this._image;
    }

    set image(value) {
        this._image = value;
    }
}
